export const socialsData = {
    github: 'https://github.com/VAIBHAV-25',
    facebook: 'https://www.facebook.com/',
    linkedIn: 'https://www.linkedin.com/in/vaibhav-singhvi-b31333159/',
    instagram: 'https://www.instagram.com/',
    codepen: 'https://codepen.io/',
    twitter: 'https://twitter.com/_Vaibhav_254',
    reddit: 'https://www.reddit.com/user/',
    blogger: 'https://www.blogger.com/',
    medium: 'https://medium.com/@vaibhavsinghvi254',
    stackOverflow: 'https://stackoverflow.com/users/',
    gitlab: 'https://gitlab.com/',
    youtube: 'https://www.youtube.com/@alphacreatix5396'
}